import { Container } from 'typedi'
import { OverviewRoute } from './services/overview-route'

Container.import([
  OverviewRoute
])

export { default as Overview } from './overview.vue'
